import { useDispatch, useSelector } from "react-redux";
import { nextStep, selectCountOfferL, selectCountOfferP, selectMinPremiumL, selectMinPremiumP, setStep } from './formSlice';
import { sendToManager } from "../home/homeApi";
import { useState } from "react";

import { TYPES_OBJECTS, list_banks } from "../../static/vars";
import { selectMortgageBalance } from "../precalc/precalcSlice";
import { selectRegAdr } from "../calc/personSlice";

export function StepTwo(props) {
    const dispatch = useDispatch();

    const min_premium_p = useSelector(selectMinPremiumP)
    const min_premium_l = useSelector(selectMinPremiumL)
    const count_offer_property = useSelector(selectCountOfferP)
    const count_offer_life = useSelector(selectCountOfferL)
    const mortgageBalance = useSelector(selectMortgageBalance)
    const regAdr = useSelector(selectRegAdr)

    const [name, setName] = useState();
    const [phone, setPhone] = useState();

    const [isS, setisS] = useState();

    const idBank = props.idBank

    const handleSendOrder = () => {
        sendToManager({
            name: name,
            phone: phone,
            addres: regAdr,
            date_start: '',
            messenger: '',
            comment: '',
            checkedSelf: true,
            bank: list_banks.find(x => x.value === idBank).label,
            limit_sum: mortgageBalance
        }, function(data) {
            // dispatch(setStep(0))
            dispatch(nextStep())
        })
    }

    const handleChangeName = (e) => {
        setName(e.target.value)
    }

    const handleChangePhone = (e) => {
        setPhone(e.target.value)
    }

    return (
        <div className="one-ekran-contant-lending-step one-ekran-contant-lending-step-2" style={{display: 'block'}}>
            <p className="lending-step-text">Мы нашли <span>{count_offer_property}</span> предложения страховых компаний</p>
            <p className="lending-step-text">Цена от: <span>{min_premium_p + min_premium_l}</span> ₽</p>
            <p className="lending-step-text">Цена действительна: <span>24</span> часа</p>
            <p className="popup-text">Что бы зафиксировать цену и получить другие предложения оставьте контактную информацию:
                Наш менеджер свяжется в ближайшее время!</p>
            <form className="form-popup form-popup-2">
                <div className="one-ryad one-ryad-popup one-ryad-popup-1 one-ryad-popup-user one-ryad-popup-user-13">
                    <label for="select-1">Ваше имя</label>
                    <input className="pole-popup pole-popup-user pole-popup-1 pole-popup-00" name="Имя" type="text" placeholder="-" required="" 
                        value={name}
                        onChange={handleChangeName}
                    />
                </div>
                <div className="one-ryad one-ryad-popup one-ryad-popup-1 one-ryad-popup-user one-ryad-popup-user-14">
                    <label for="select-1">Телефон</label>
                    <input className="pole-popup pole-popup-user pole-popup-1 pole-popup-00" name="Адрес" type="text" placeholder="+7" required="" 
                        value={phone}
                        onChange={handleChangePhone}
                    />
                </div>
                <div className="checkbox-1-3-box">
                    <input className="checkbox-1 checkbox-1-3" type="checkbox" id="scales" name="zakon" defaultValue="" defaultChecked="" />
                    <label for="scales">Принимаю правила страхования</label>
                </div>
                <div onClick={handleSendOrder} className="button button-1 button-popup-1 button-lending-2">Получить расчёт</div>
            </form>
        </div>
    )
}